module.exports = __webpack_public_path__ + "a6dd3973245a7ea09a91f152f9eb6094.png";